import apiClient from './apiClient';
import.meta.env;

// Registration interfaces
export interface CourseRegistrationRequest {
  classroomId: number;
  message?: string;
  promotion_id?: number;
  promotion_user_id?: number;
  /** @deprecated Ưu tiên invoiceType */
  needsCompanyInvoice?: boolean;
  /** none | personal | company */
  invoiceType?: 'none' | 'personal' | 'company';
  invoiceFullName?: string;
  invoiceEmail?: string;
  invoiceCccd?: string;
  invoiceAddress?: string;
}

export interface RegistrationResponse {
  success: boolean;
  message: string;
  data: {
    registration: Registration;
    payment: PaymentInfo;
  };
  errors: string[];
  timestamp: string;
  requestId: string;
}

export interface Registration {
  id: number;
  userId: number;
  courseId: number;
  classroomId: number;
  code: string;
  fee: number;
  originalFee?: number;
  discountAmount?: number;
  registerAt: string;
  status: 'wait_payment' | 'success' | 'cancelled';
  expirePaymentDate?: string;
  approvedAt?: string;
  approveNote?: string;
  approveBy?: number | string;
  sharedVideo: boolean;
  sharedDoc: boolean;
  entryNumber?: string;
  promotionId?: number;
  promotionUserId?: number;
  zaloAdded: boolean;
  createdAt: string;
  updatedAt: string;
  needsCompanyInvoice?: boolean;
  invoiceType?: 'NONE' | 'PERSONAL' | 'COMPANY';
}

export interface PaymentInfo {
  /** false = nhánh HĐ công ty (không QR). undefined = API cũ → coi như có QR */
  showQr?: boolean;
  hotline?: string;
  bankAccount?: string;
  bankName?: string;
  amount?: number;
  transferContent?: string;
  deadline: string;
  qrCode?: string;
}

export interface PromotionInfo {
  promotionId: number | null;
  promotion_user_Id: number | null;
  discountAmount: number;
  fee: number;
  orgFee: number;
}

export interface StudentRegistrationListResponse {
  success: boolean;
  message: string;
  data: Array<Registration & {
    course: {
      id: number;
      title: string;
      courseCode: string;
    };
    classroom?: {
      id: number;
      classCode: string;
      startDate: string;
      endDate: string;
      maxStudent: number;
      totalRegistered: number;
    };
  }>;
  pagination: {
    page: number;
    limit: number;
    total: number;
    totalPages: number;
  };
  errors: string[];
  timestamp: string;
  requestId: string;
}

// Using centralized API client with automatic token refresh

export const RegistrationApi = {
  /**
   * Create a new course registration
   */
  createRegistration: async (request: CourseRegistrationRequest): Promise<RegistrationResponse> => {
    const response = await apiClient.post<RegistrationResponse>('/registrations', request);
    return response.data;
  },

  /**
   * Get student's own registrations
   */
  getMyRegistrations: async (page = 1, limit = 10): Promise<StudentRegistrationListResponse> => {
    const response = await apiClient.get<StudentRegistrationListResponse>(
      `/registrations?page=${page}&limit=${limit}`
    );
    return response.data;
  },

  /**
   * Get registration by ID (if student owns it)
   */
  getRegistrationById: async (registrationId: number): Promise<Registration> => {
    const response = await apiClient.get<{ data: Registration }>(`/registrations/${registrationId}`);
    return response.data.data;
  },

  /**
   * Get best promotion information for a specific course
   */
  getBestPromotion: async (courseId: number): Promise<PromotionInfo> => {
    const response = await apiClient.get<PromotionInfo>(`/promotions/best?courseId=${courseId}`);
    return response.data;
  },
};

export default RegistrationApi;